import {
  faFile,
  faHospital,
  faUser,
} from "@fortawesome/free-regular-svg-icons";
import {
  faCameraRetro,
  faHistory,
  faLayerGroup,
  faTasks,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { getResourcePath } from "routers/constant";

export const MENUITEMS = [
  {
    menutitle: "Trang chủ",
    menucontent: "Dashboards,Widgets",
    Items: [
      { path: "/trang-chu", title: "Thống kê", icon: faHospital, type: "link" },
      {
        path: getResourcePath("bao-cao", "list"),
        title: "Báo cáo",
        icon: faTasks,
        type: "link",
      },
    ],
  },
  {
    menutitle: "Chức năng chính",
    menucontent: "Dashboards,Widgets",
    Items: [
      {
        title: "Hồ Sơ vi phạm",
        icon: faFile,
        type: "link",
        path: getResourcePath("ho-so-vi-pham", "list"),
      },
      {
        title: "Theo dõi vi phạm",
        icon: faCameraRetro,
        type: "link",
        path: getResourcePath("theo-doi-vi-pham", "list"),
      },
      {
        title: "Quản lý đối tượng vi phạm",
        icon: faUser,
        type: "link",
        path: getResourcePath("doi-tuong-vi-pham", "list"),
      },
    ],
  },
  {
    menutitle: "Quản lý tài khoản",
    Items: [
      {
        title: "Danh sách tài khoản",
        icon: faUsers,
        type: "link",
        path: getResourcePath("ho-so-ca-nhan", "list"),
      },
      {
        title: "Phân quyền",
        icon: faLayerGroup,
        type: "link",
        path: "/phan-quyen",
      },
    ],
  },
  {
    menutitle: "Lịch sử thao tác",
    Items: [
      {
        icon: faHistory,
        title: "Lịch sử người dùng",
        path: getResourcePath("lich-su-thanh-toan", "list"),
        type: "link",
      },
    ],
  },
];
